<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="listQuery.keyword"
            placeholder="品牌编码/名称/标语"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="品牌编码">
          <el-input
            v-model="listQuery.code"
            placeholder="精确查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="品牌名称">
          <el-input
            v-model="listQuery.name"
            placeholder="精确查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="更新时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <li-cheng-sync-button
            resource="brand"
            label="同步品牌"
            @synced="getList"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="filter-container" style="margin-bottom: 10px">
      <el-button type="primary" size="small" @click="handleCreate">
        新增
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="品牌编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.code }}
        </template>
      </el-table-column>

      <el-table-column label="品牌名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="品牌标语" min-width="200" align="center">
        <template slot-scope="scope">
          {{ scope.row.slogan }}
        </template>
      </el-table-column>
      <!-- 增加一个logo_url -->
      <el-table-column label="品牌Logo" min-width="100" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.logo_url"
            :src="scope.row.logo_url"
            style="width: 40px; height: 40px; object-fit: contain"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleUpdate(scope.row)"
          >
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogStatus === 'create' ? '新增品牌' : '编辑品牌'"
      :visible.sync="dialogFormVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="品牌编码" prop="code">
          <el-input v-model="form.code" placeholder="请输入品牌编码" />
        </el-form-item>
        <el-form-item label="品牌名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入品牌名称" />
        </el-form-item>
        <el-form-item label="品牌标语" prop="slogan">
          <el-input
            v-model="form.slogan"
            placeholder="请输入品牌标语"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
        <el-form-item label="品牌Logo" prop="logo_url">
          <el-input v-model="form.logo_url" placeholder="请输入品牌Logo URL" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        keyword: undefined,
        code: undefined,
        name: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 弹窗相关
      dialogFormVisible: false,
      dialogStatus: '',
      btnLoading: false,
      form: {
        id: undefined,
        code: '',
        name: '',
        slogan: '',
        logo_url: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList() {
      this.listLoading = true
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_at = this.dateRange[0]
        this.listQuery.end_at = this.dateRange[1]
      } else {
        this.listQuery.start_at = undefined
        this.listQuery.end_at = undefined
      }

      request({
        url: '/api/backend/liCheng/hotel/brandList',
        method: 'get',
        params: this.listQuery,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        keyword: undefined,
        code: undefined,
        name: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 新增弹窗
    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
    },
    // 编辑弹窗
    handleUpdate(row) {
      this.form = Object.assign({}, row)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
    },
    // 重置表单
    resetForm() {
      this.form = {
        id: undefined,
        code: '',
        name: '',
        slogan: '',
        logo_url: '',
      }
      this.btnLoading = false
    },
    // 保存数据（新增/编辑）
    saveData() {
      // TODO: 调用新增/编辑接口
      // const url = this.dialogStatus === 'create'
      //   ? '/api/backend/liCheng/hotel/brandCreate'
      //   : '/api/backend/liCheng/hotel/brandUpdate'
      // request({
      //   url,
      //   method: 'post',
      //   data: this.form
      // }).then(() => {
      //   this.dialogFormVisible = false
      //   this.$message({ type: 'success', message: '操作成功' })
      //   this.getList()
      // })

      this.$message({
        type: 'info',
        message: '新增/编辑功能待实现',
      })
    },
    // 删除操作
    handleDelete(row) {
      this.$confirm('确认删除该品牌？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // TODO: 调用删除接口
          // request({
          //   url: '/api/backend/liCheng/hotel/brandDelete',
          //   method: 'post',
          //   data: { id: row.id }
          // }).then(() => {
          //   this.$message({ type: 'success', message: '删除成功' })
          //   this.getList()
          // })

          this.$message({
            type: 'info',
            message: '删除功能待实现',
          })
        })
        .catch(() => {
          // 取消删除
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
</style>
